import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Portlet, Button, Form, Row, Col } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const EditarCentroCostoModal = () => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _idCentroCostoNivel1: '',
      _idCentroCostoNivel2: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Descargando reporte relacion asientos - centros')
      AsientoContableService.descargarRelacionAsientosCentros(data)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
          __zariContext.toast('success', 'Reporte descargado satisfactoriamente.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Reporte Relacion Asientos - Centros' />
      <Portlet.Body>
        <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
          {({ handleSubmit, errors, touched, values, isSubmitting }) => (
            <Form>
              <FormGroups.CentroCostoNivel1FormGroup
                fIsSubmitting={isSubmitting}
                iError={errors._idCentroCostoNivel1}
                iTouched={touched._idCentroCostoNivel1}
              />
              <FormGroups.CentroCostoNivel2FormGroup
                fIsSubmitting={isSubmitting}
                iError={errors._idCentroCostoNivel2}
                iTouched={touched._idCentroCostoNivel2}
                idNodoPadre={values._idCentroCostoNivel1}
              />
              <Row>
                <Col md={12} className='text-right'>
                  <Button tiny onClick={handleSubmit} disabled={isSubmitting}>
                    Descargar
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(EditarCentroCostoModal)
